import ApiClient from '../ApiClient';

class CrmCustomFieldDefinitionsAPI extends ApiClient {
    constructor() {
        super('crm/custom_field_definitions', { accountScoped: true });
    }
}
export default new CrmCustomFieldDefinitionsAPI();
